import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackService } from 'src/app/services/snack.service';
import { AppSnackBaseComponent } from './snack-base.component';

export interface AppSnackData {
  message?: string;
};

@Component({
  selector: 'app-snack',
  template: `<span class="mat-simple-snack-bar-content">{{message}}</span>`,
  styles: [],
  encapsulation: ViewEncapsulation.None,
  host: { 'class': 'mat-simple-snackbar' },
  standalone: false
})
export class AppSnackComponent extends AppSnackBaseComponent {
  message: string;

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public snackBarRef: MatSnackBarRef<AppSnackComponent>,
    @Inject(MAT_SNACK_BAR_DATA) data: AppSnackData,
  ) {
    super(changeDetectorRef, snackBarRef);

    this.message = typeof data === 'string' ? data : data?.message;
  }
}
